import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-event-table',
  templateUrl: './event-table.component.html',
  styleUrls: ['./event-table.component.scss']
})
export class EventTableComponent implements OnInit {

  @Input('table-data') tableData: any[] = [];
  @Input('page') page: number = 1;
  @Output('action') action = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {
  }

  onDeleteClick(data: any) {
    this.action.emit({
      isAddSloka: false,
      isEdit: false,
      isDelete: true,
      isView: false,
      data: data,
    });
  }

  onEditClick(data: any) {
    this.action.emit({
      isAddSloka: false,
      isEdit: true,
      isDelete: false,
      isView: false,
      data: data,
    });
  }

  onViewClick(data: any) {
    this.action.emit({
      isAddSloka: false,
      isEdit: false,
      isDelete: false,
      isView: true,
      data: data,
    });
  }

}
